import React from 'react';
import { Modal } from 'react-bootstrap';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

export const OfflineBanner: React.FC = () => {
    const isOnline = useOnlineStatus();

    return (
        <Modal
            show={!isOnline}
            backdrop="static"
            keyboard={false}
            centered
            size="sm"
        >
            <Modal.Body>
                <div className="modal-status bg-danger"></div>
                <div className="text-center py-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="48"
                        height="48"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon mb-3 text-danger icon-lg"
                    >
                        <line x1="1" y1="1" x2="23" y2="23"></line>
                        <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path>
                        <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path>
                        <path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path>
                        <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path>
                        <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
                        <line x1="12" y1="20" x2="12.01" y2="20"></line>
                    </svg>
                    <h3>Žiadne internetové pripojenie</h3>
                    <div className="text-secondary">
                        Pripojenie k internetu sa stratilo. Skontrolujte vaše sieťové nastavenia a skúste to znova.
                    </div>
                    <div className="mt-3">
                        <div className="spinner-border spinner-border-sm text-danger" role="status">
                            <span className="visually-hidden">Čakám na pripojenie...</span>
                        </div>
                        <div className="text-muted small mt-2">
                            Čakám na obnovenie pripojenia...
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};
